import script from "./introduce.vue?vue&type=script&setup=true&lang=js"
export * from "./introduce.vue?vue&type=script&setup=true&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=0d8ff5df&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d8ff5df"]])

export default __exports__